export interface IFsMapPopupEvents {
  open: undefined;
  close: undefined;
  lonLatChange: undefined;
}
